	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
         <!--Laboratory form  -->
         <div class="ui form" [formGroup]="projectForm">

                <div class="field" [ngClass]="displayFieldCss('referenceNo')">
                  <label>Company Name </label>
                                    <input  formControlName="referenceNo" type="text" placeholder="Enter company name">
                  <app-field-error-display [displayError]="isFieldValid('referenceNo')" errorMsg="Please company name">
                  </app-field-error-display>
            </div>

               <div class="field" [ngClass]="displayFieldCss('selection_method')">
                  <label>Company Address</label>
                  <textarea rows="2" placeholder="Enter Company Address" ></textarea>
                        <app-field-error-display [displayError]="isFieldValid('selection_method')" errorMsg="Please select unit">
                  </app-field-error-display>
                  </div>

                  <div class="field" [ngClass]="displayFieldCss('referenceNo')">
                  <label>Company Email </label>
                                    <input  formControlName="referenceNo" type="text" placeholder="Enter email address">
                  <app-field-error-display [displayError]="isFieldValid('referenceNo')" errorMsg="Please enter email address">
                  </app-field-error-display>
            </div>
                  <div class="field" [ngClass]="displayFieldCss('referenceNo')">
                  <label>Phone Number</label>
                         <input  formControlName="referenceNo" type="text" placeholder="Enter phone number">
                  <app-field-error-display [displayError]="isFieldValid('referenceNo')" errorMsg="Please enter phone number">
                  </app-field-error-display>
            </div>


            <div class="field" [ngClass]="displayFieldCss('selection_method')">
                  <label>Main Contact</label>
                      <input  formControlName="referenceNo" type="text" placeholder="Enter main contact name">
                        <app-field-error-display [displayError]="isFieldValid('selection_method')" errorMsg="Please select department">
                  </app-field-error-display>
                        </div>
                      <div class="field" [ngClass]="displayFieldCss('selection_method')">
                  <label>Contact Email Address</label>
                      <input  formControlName="referenceNo" type="text" placeholder="Enter main contact email address">
                        <app-field-error-display [displayError]="isFieldValid('selection_method')" errorMsg="Please select department">
                  </app-field-error-display>
                        </div>


            <div class="field" [ngClass]="displayFieldCss('selection_method')">
                  <label>Company Summary</label>
                  <textarea rows="2" ></textarea>
                        <app-field-error-display [displayError]="isFieldValid('selection_method')" errorMsg="Please select unit">
                  </app-field-error-display>
                  </div>




    </div>

 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Save</button>

      </div>


